const CheckListConstants = {
  GET_CHECKLIST_DETAILS_SUCCESS: "GET_CHECKLIST_DETAILS_SUCCESS",
  GET_CHECKLIST_DETAILS_FAILURE: "GET_CHECKLIST_DETAILS_FAILURE",
  GET_ANLAGE_CHECKLIST_SUCCESS: "GET_ANLAGE_CHECKLIST_SUCCESS",
  GET_ANLAGE_CHECKLIST_FAILURE: "GET_ANLAGE_CHECKLIST_FAILURE",
  SAVE_INSPECTION_SUCCESS: "SAVE_INSPECTION_SUCCESS",
  SAVE_INSPECTION_FAILURE: "SAVE_INSPECTION_FAILURE",
};

export default CheckListConstants;
